document.addEventListener("DOMContentLoaded", function () {

  const sectionsConfig = [
    {
      info: '#shopify-section-template--19355113226390__container_7f6yJP',
      mapa: '#shopify-section-template--19355113226390__mapa_fVTL6x',
      background: 'transparent' // Página Fale Conosco
    },
    {
      info: '#shopify-section-template--19351532109974__container_WBrc6x',
      mapa: '#shopify-section-template--19351532109974__mapa_CNFahU',
      background: '#022C2E' // Página Institucional
    },
    {
      info: '#shopify-section-template--19351332454550__container_RJVcRk',
      mapa: '#shopify-section-template--19351332454550__mapa_aAFa8r',
      background: '#022C2E' // Página Institucional
    }
  ];

  sectionsConfig.forEach(section => {

    const divInfo = document.querySelector(section.info);
    const divMapa = document.querySelector(section.mapa);

    if (divInfo && divMapa) {

      if (divInfo.closest('.container-geral-custom')) return;

      const containerGeral = document.createElement('div');
      containerGeral.className = 'container-geral-custom';

      // 🔥 aplica background dinâmico
      containerGeral.style.background = section.background;

      const containerPai = document.createElement('div');
      containerPai.className = 'container-pai-custom';

      divInfo.parentNode.insertBefore(containerGeral, divInfo);

      containerGeral.appendChild(containerPai);
      containerPai.appendChild(divInfo);
      containerPai.appendChild(divMapa);
    }

  });

const banner = document.getElementById('shopify-section-template--19248503554198__banner_custom_nR3WHw');
const product = document.getElementById('shopify-section-template--19248503554198__torre_personalizado_XfMfMW');

if (banner && product) {
  const container = document.createElement('div');
  container.id = 'custom-torre-hero-container';
  container.style.cssText = 'position: relative; height: 1250px;';

  banner.parentNode.insertBefore(container, banner);
  container.appendChild(banner);
  container.appendChild(product);
}


});


/* div pai envolvendo duas divs na home para line draw da xicara de cafe*/
document.addEventListener("DOMContentLoaded", function () {
  const filho1 = document.querySelector(
    "#shopify-section-template--19248503554198__assinatura_ladovas_dDjyfe"
  );

  const filho2 = document.querySelector(
    "#shopify-section-template--19248503554198__split_image_drawing_bnjkGn"
  );

  const filho3 = document.querySelector(
    "#shopify-section-template--19248503554198__container_YeMPxc"
  );

  if (filho1 && filho2 && filho3) {
    // cria a div pai
    const pai = document.createElement("div");
    pai.className = "container-assinatura-home";

    // insere a div pai antes do primeiro elemento
    filho1.parentNode.insertBefore(pai, filho1);

    // move os filhos para dentro da div pai
    pai.appendChild(filho1);
    pai.appendChild(filho2);
    pai.appendChild(filho3);
  }
});


/* div pai envolvendo duas divs na home para line draw da xicara de cafe*/
document.addEventListener("DOMContentLoaded", function () {
  const line1 = document.querySelector(
    "#custom-torre-hero-container"
  );

  const line2 = document.querySelector(
    "#shopify-section-template--19248503554198__split_image_drawing_UXrpRU"
  );

  const line3 = document.querySelector(
    "#shopify-section-template--19248503554198__macarons_cardtower_NwcCgc"
  );


  if (line1 && line2 && line3) {
    // cria a div pai
    const mainline = document.createElement("div");
    mainline.className = "container-line-home";

    // insere a div pai antes do primeiro elemento
    line1.parentNode.insertBefore(mainline, line1);

    // move os filhos para dentro da div pai
    mainline.appendChild(line1);
    mainline.appendChild(line2);
    mainline.appendChild(line3);
  }
});